import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

// Autres modules externes utilises 

// Modules communs utilises
import { EventsModule } from '../../technical-modules/events/event-bus.module';

// Composants metiers
import { RefreshButtonComponent } from './components/refresh-button.component';

// Services metier
import { UserModule } from '../../data-domains/humain/user/user.module';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		
		EventsModule,
		
		UserModule,
	],
	providers: [
	],
	declarations: [
		RefreshButtonComponent,
	],
	exports: [
		RefreshButtonComponent,
	]
})
export class HeaderModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('refreshButton',
		downgradeComponent({ component: RefreshButtonComponent })
	) //
;